export function setBook (state, book){
  state.book = book
}

export function booksError(state, payload){
  state.error = true
  state.errorMessage = payload
}

export function setCategories (state, categories){
  state.categories = categories
}

export function categoriesError(state, payload){
  state.error = true
  state.errorMessage = payload
}